<template>
    <div :style="cssProps">
        <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
            <div class="row mb-2">
                <div class="col">
                    <h1 class="text-white pt-3 px-3">เติมเครดิตเข้ากระเป๋า</h1>
                    <p class="text-white pb-3 px-3">เลือกจำนวนเครดิต หรือ ระบุจำนวนเครดิต เพื่อทำการเติมเข้ากระเป๋าของคุณ
                    </p>
                </div>
            </div>
        </base-header>
        <div class="text-center" v-if="busy">
            <BlockUI>
                <div class="loader"></div>
            </BlockUI>
        </div>
        <div class="container-fluid mt--8 mb-5">
            <div class="row">
                <div class="col">
                    <div class="card shadow py-5">
                        <div class="col-lg-12">
                            123
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import {hexToRgbA} from "@/plugins/hexColor";

export default {
    name: "",
    data() {
        return {
            busy: false
        }
    },
    created() {

    },
    mounted() {

    },
    methods: {

    },
    computed: {
        cssProps() {
            return {
                '--bg-hover-color': hexToRgbA('#11cdef', 0.7),
                '--bg-color': '#11cdef',
            }
        }
    }
};
</script>
<style scoped>

</style>
